/* 1) Auto-switch unavailable variant combinations.
   選択中のボタンが取り消し線(disabled)になったら、選択可能な値に自動で切り替えます。
   お客様が直前に自分で操作したグループは対象外。
   2) Variant image sync.
   バリアント切替後、選択中の画像を is-active に。表示位置(末尾/価格の直上)はCSSのorderで制御し、
   DOMの並び替え(appendChild)はしない（読み込み時・切替時のガタつき/スクロール飛び防止）。 */
(function () {
  if (window.__autoVariantSwitchLoaded) return;
  window.__autoVariantSwitchLoaded = true;

  var DISABLED = ['disabled', 'visually-disabled'];
  var autoFixCount = 0;
  var resetTimer = null;
  var userTouchedIndex = -1;

  function isDisabled(input) {
    for (var i = 0; i < DISABLED.length; i++) {
      if (input.classList.contains(DISABLED[i])) return true;
    }
    return false;
  }

  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var vs = t.closest('variant-selects');
    if (!vs) return;
    var fieldsets = vs.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      if (fieldsets[i].contains(t)) { userTouchedIndex = i; return; }
    }
  }, true);

  function fixPicker(vs) {
    var fieldsets = vs.querySelectorAll('fieldset');
    for (var f = 0; f < fieldsets.length; f++) {
      if (f === userTouchedIndex) continue;
      var fs = fieldsets[f];
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (!checked || !isDisabled(checked)) continue;
      var inputs = fs.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (!isDisabled(inputs[i])) {
          checked.checked = false;
          inputs[i].checked = true;
          return inputs[i];
        }
      }
    }
    return null;
  }

  function run() {
    if (autoFixCount >= 8) return;
    var pickers = document.querySelectorAll('variant-selects');
    for (var i = 0; i < pickers.length; i++) {
      var fixed = fixPicker(pickers[i]);
      if (fixed) {
        autoFixCount++;
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () { autoFixCount = 0; }, 2000);
        fixed.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  var scheduled = null;
  var observer = new MutationObserver(function () {
    clearTimeout(scheduled);
    scheduled = setTimeout(run, 60);
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* ---- 2) Variant image sync ---- */
  function syncGallery(variant) {
    var fm = variant && variant.featured_media;
    if (!fm || !fm.id) return;
    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var list = gallery.querySelector('ul.product__media-list');
      if (!list) return;
      var lis = list.querySelectorAll('li[data-media-id]');
      if (!lis.length) return;
      var target = null;
      lis.forEach(function (li) {
        if (li.dataset.mediaId && li.dataset.mediaId.slice(-String(fm.id).length - 1) === '-' + fm.id) target = li;
      });
      if (!target && fm.preview_image && fm.preview_image.src) {
        // Dawnが新スライドを挿入できなかった場合: 既存アクティブスライドの画像を差し替え
        var li = list.querySelector('li[data-media-id].is-active') || lis[lis.length - 1];
        var img = li.querySelector('img');
        if (!img) return;
        var src = fm.preview_image.src;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1946';
        img.removeAttribute('srcset');
        if (fm.alt) img.alt = fm.alt;
        target = li;
      }
      if (!target) return;
      lis.forEach(function (li) { li.classList.remove('is-active'); });
      target.classList.add('is-active');
      // 表示位置はCSSのorderで制御（is-active を末尾に）。DOMのappendChildはしない。
    });
  }

  var syncTries = 0;
  function initMediaSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS || !PUB_SUB_EVENTS.variantChange) {
      if (syncTries++ < 100) setTimeout(initMediaSync, 200);
      return;
    }
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      try {
        var v = event && event.data && event.data.variant;
        setTimeout(function () { try { syncGallery(v); } catch (e) {} }, 120);
      } catch (e) { /* noop */ }
    });
  }
  initMediaSync();
})();
